import styled from 'styled-components';

import media from '@/styles/media.style';
import { BLACK, WHITE, BG_GRAY } from '@/styles/variables.style';

export const Wrapper = styled.div`
  margin-bottom: 68px;
`;

export const VideoWrapper = styled.section`
  margin: 0 auto 20px;
  max-width: 100%;
  width: 1000px;
  padding: 40px 20px 0;

  ${media.tabletL`
    margin: 0 auto 60px;
    padding: 60px 20px 0;
  `};
`;

export const YoutubeSectionWrapper = styled.section`
  margin: 0 auto;
  max-width: 100%;
  width: 1000px;
  padding: 0 20px;
`;

export const YoutubeSection = styled.div``;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => height};
  margin: 0;
`;

export const Button = styled.div`
  align-items: center;
  background-color: ${BLACK};
  color: ${WHITE};
  display: flex;
  font-size: 14px;
  font-weight: 800;
  height: 53px;
  justify-content: center;
  line-height: 53px;
  letter-spacing: 2px;
  width: 220px;
  text-align: center;
  text-transform: uppercase;

  ${media.tabletL`
    height: 72px;
    line-height: 72px;
    width: 300px;
  `};
`;

export const PlaceholderWrapper = styled.div`
  margin: 0;
`;

export const Hr = styled.div`
  width: 30px;
  height: 2px;
  background: ${BG_GRAY.COMMON_6};
  margin: ${({ margin }) => margin};
`;



// WEBPACK FOOTER //
// ./src/pages/StylePage/StylePage.style.js